import { Reducer } from 'redux';
import { CodelistsActions } from './actionType';
import { IrelandCodelistTypes, UkCodelistTypes, UkNctsCodelists } from './code';
import { SelectOption } from 'components/ui/composed/declarations/formSelect/DeclarationSelect';

export interface CodelistsState {
    irelandCodelists?: IrelandCodelistTypes;
    ukCodelists?: UkCodelistTypes;
    UkNctsCodelists?: UkNctsCodelists;
    ieUnloPagination?: { page: number; count: number };
    ukUnloPagination?: { page: number; count: number };
    ics2Codelists?: Record<string, SelectOption[]>;
    ieCodelistsLoading: boolean;
    ukCodelistsLoading: boolean;
}

export const codelistsInitialState: Readonly<CodelistsState> = {
    ieCodelistsLoading: false,
    ukCodelistsLoading: false,
};

const codelists: Reducer<CodelistsState, CodelistsActions> = (
    state = codelistsInitialState,
    action: CodelistsActions
) => {
    switch (action.type) {
        case 'GET_IRELAND_CODELISTS_REQUEST':
            return {
                ...state,
                ieCodelistsLoading: true,
            };
        case 'GET_IRELAND_CODELISTS_SUCCESS':
            return {
                ...state,
                ieCodelistsLoading: false,
                irelandCodelists: {
                    ...state.irelandCodelists,
                    ...action.payload,
                    ncts: action.payload?.ncts
                        ? {
                              ...action.payload.ncts,
                              unLocodeExtended: state.irelandCodelists?.ncts?.unLocodeExtended ?? [],
                          }
                        : state.irelandCodelists?.ncts,
                },
            };
        case 'GET_IRELAND_UNLOCODEEXTENDED_CODELISTS_SUCCESS':
            return {
                ...state,
                ieCodelistsLoading: false,
                irelandCodelists: {
                    ...state.irelandCodelists,
                    ncts: {
                        ...state.irelandCodelists?.ncts,
                        unLocodeExtended: [
                            ...(state.irelandCodelists?.ncts?.unLocodeExtended ?? []),
                            ...(action.payload.list ?? []),
                        ],
                    },
                },
                ieUnloPagination: {
                    page: action.payload.pageNumber ?? 0,
                    count: action.payload.total ?? 0,
                },
            };
        case 'GET_IRELAND_CODELISTS_ERROR':
            return {
                ...state,
                ieCodelistsLoading: false,
                irelandCodelists: action.payload,
            };
        case 'GET_UK_CODELISTS_REQUEST':
            return {
                ...state,
                ukCodelistsLoading: true,
            };
        case 'GET_UK_CODELISTS_SUCCESS':
            return {
                ...state,
                ukCodelistsLoading: false,
                ukCodelists: {
                    ...state.ukCodelists,
                    ...action.payload,
                    ncts: action.payload?.ncts
                        ? {
                              ...action.payload.ncts,
                              unLocodeExtended: state.ukCodelists?.ncts?.unLocodeExtended ?? [],
                          }
                        : state.ukCodelists?.ncts,
                },
            };
        case 'GET_UK_UNLOCODEEXTENDED_CODELISTS_SUCCESS':
            return {
                ...state,
                ukCodelistsLoading: false,
                ukCodelists: {
                    ...state.ukCodelists,
                    ncts: {
                        ...state.ukCodelists?.ncts,
                        unLocodeExtended: [
                            ...(state.ukCodelists?.ncts?.unLocodeExtended ?? []),
                            ...(action.payload.list ?? []),
                        ],
                    },
                },
                ukUnloPagination: {
                    page: action.payload.pageNumber ?? 0,
                    count: action.payload.total ?? 0,
                },
            };
        case 'GET_UK_CODELISTS_ERROR':
            return {
                ...state,
                ukCodelistsLoading: false,
                ukCodelists: action.payload,
            };
        case 'GET_ICS2_CODELIST_SUCCESS':
            return {
                ...state,
                ics2Codelists: {
                    ...state.ics2Codelists,
                    [action.payload.codelistName]: action.payload.values,
                },
            };

        default:
            return state;
    }
};

export default codelists;
